import React, { createContext, useContext, useState } from 'react'

interface OrdersReportContextData {
  setFilters: React.Dispatch<React.SetStateAction<any>>
  filters: any
}

export const OrdersReportContext = createContext<OrdersReportContextData>(
  {} as OrdersReportContextData
)

export const OrdersReportProvider: React.FC = ({ children }) => {
  const [filters, setFilters] = useState<any>({})

  return (
    <OrdersReportContext.Provider
      value={{
        setFilters,
        filters
      }}
    >
      {children}
    </OrdersReportContext.Provider>
  )
}

export function useOrdersReportContext() {
  return useContext(OrdersReportContext)
}
